import React, {Component} from 'react';
import WeekDayLong from "./week_day_long";
import moment from "moment";
import WeekDayDraggable from "./week_day_draggable";
import WeekDayDroppable from "./week_day_droppable";
import "./week_day.css";

export default class WeekDay extends Component {
	constructor(props) {
		super(props);
		this.makeBusDay = this.makeBusDay.bind(this);
		this.setBusDay = this.setBusDay.bind(this);
	}

	makeBusDay() {
		return this.props.uid;
	}

	setBusDay() {
		if (this.props.busDay.busDay === this.makeBusDay()) {
			this.props.busDay.setBusDay(null);
		} else {
			this.props.busDay.setBusDay(this.makeBusDay());
			function absolutePosition(el) {
				var
					found,
					left = 0,
					top = 0,
					width = 0,
					height = 0,
					offsetBase = absolutePosition.offsetBase;
				if (!offsetBase && document.body) {
					offsetBase = absolutePosition.offsetBase = document.createElement('div');
					offsetBase.style.cssText = 'position:absolute;left:0;top:0';
					document.body.appendChild(offsetBase);
				}
				if (el && el.ownerDocument === document && 'getBoundingClientRect' in el && offsetBase) {
					var boundingRect = el.getBoundingClientRect();
					var baseRect = offsetBase.getBoundingClientRect();
					found = true;
					left = boundingRect.left - baseRect.left;
					top = boundingRect.top - baseRect.top;
					width = boundingRect.right - boundingRect.left;
					height = boundingRect.bottom - boundingRect.top;
				}
				return {
					found: found,
					left: left,
					top: top,
					width: width,
					height: height,
					right: left + width,
					bottom: top + height
				};
			}

			//get ref to long day
			let {scrollLeft, offsetWidth, offsetLeft} = window["app-calendar"];
			let {left, width} = this.weekDay.getBoundingClientRect();
			window["app-calendar"].scrollLeft = left - (offsetWidth - scrollLeft) + offsetWidth - (3.5 * width) + 8;
		}
	}

	render() {
		const {date, busId, external} = this.props;
		if (this.props.moves && this.props.moves.length > 0 && this.props.moves[0].render === -1) {
			let activeDay = this.context.getActive() === this.props.moves[0].id;
			return (
				<WeekDayDroppable busId={this.props.busId} onClick={()=>this.context.setActive(this.props.moves[0].id)}
				                  external={external}
				                  activeDay={activeDay} date={date}>
					<WeekDayDraggable move={{...this.props.moves[0],date,busId}}/>
				</WeekDayDroppable>
			);
		}
		if (!this.props.moves) {
			return (
				<WeekDayDroppable busId={this.props.busId} date={date}/>
			);
		} else {

			let show = this.props.busDay.busDay === this.makeBusDay();
			let sortedMoves = this.props.moves.sort((a, b)=> {
				return moment(a.salida, "HH:mm:ss").toDate() - moment(b.salida, "HH:mm:ss").toDate();
			});
			let movesWithDates = sortedMoves.map(move=> {
				return {
					...move,
					date,
					busId,
					external
				}
			});

			let moves = movesWithDates.map((move)=><WeekDayDraggable move={move} key={move.id}/>);
			return (
				<WeekDayDroppable busId={this.props.busId} onClick={this.setBusDay} date={date} isOpen={show}
				                  external={external}
				                  refQ={(ref)=>this.weekDay = ref}>
					{moves}
					<WeekDayLong show={show} moves={this.props.moves}/>
				</WeekDayDroppable>
			)
		}
	}
}

WeekDay.propTypes = {
	moves: React.PropTypes.arrayOf(React.PropTypes.object)
}

WeekDay.contextTypes = {
	setActive: React.PropTypes.func,
	getActive: React.PropTypes.func
}


/** WEBPACK FOOTER **
 ** ./src/components/week_day.js
 **/